// appwrite.service.ts
import { Injectable } from '@angular/core';
import { Storage } from 'appwrite';
import { storage, BucketId } from '../helpers/appwrite';

@Injectable({
  providedIn: 'root',
})
export class AppwriteService {
  private readonly storage: Storage;

  constructor() {
    this.storage = storage;
  }

  getImageUrl(imageId: string, width: number, height: number): string {
    return this.storage.getFileView(BucketId, imageId).toString();
  }
}
